// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-section {
  padding: 8rem 0;
}
.services-section .latest-news-update-btn-container {
  position: relative;
}
.services-section .latest-news-update-btn-container .update-btn {
  position: absolute;
  top: -115px;
  right: 1rem;
}
.services-section .services-update-btn-container {
  position: relative;
}
.services-section .services-update-btn-container .update-btn {
  position: absolute;
  right: 1rem;
  top: 65px;
}

.services-update-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 2rem;
  min-height: 55vh;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.services-update-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.services-update-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.services-update-section .custom-container .content-body {
  margin: 3rem auto 0;
}
.services-update-section .custom-container .content-body .form__div-container {
  margin-bottom: 2.5rem;
}
.services-update-section .custom-container .content-body .form__div-container .service-image-container {
  position: relative;
}
.services-update-section .custom-container .content-body .form__div-container .service-image-container .service-icon {
  height: 100px;
  width: 100px;
  object-fit: contain;
}
.services-update-section .custom-container .content-body .form__div-container .service-image-container .image-uploader {
  position: absolute;
  top: -30px;
  left: 85px;
}
.services-update-section .custom-container .content-body .form__div-container .service-image-container .image-uploader .icon-update-btn {
  height: 40px;
  width: 40px;
  background: #b4b4b4;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  transition: 0.4s;
}
.services-update-section .custom-container .content-body .form__div-container .service-image-container .image-uploader .icon-update-btn .fa-pencil {
  font-size: 18px;
}
.services-update-section .custom-container .content-body .form__div-container .service-image-container .image-uploader .icon-update-btn:hover {
  background: gray;
}
.services-update-section .custom-container .content-body .form__div-container .form__div .form__input {
  border-color: #878787;
}
.services-update-section .custom-container .content-body .form__div-container .form__div .form__input:focus {
  border-color: #1a73e8;
}
.services-update-section .custom-container .content-body .form__div-container .form__div .form__label {
  background: #E0E7FF;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/home/services.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AADN;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAHN;;AAYI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AATN;AAWM;EACE,iBCxBK;EDyBL,kBAAA;EACA,cAAA;AATR;AAWQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AATV;AAcI;EACE,mBAAA;AAZN;AAcM;EACE,qBAAA;AAZR;AAcQ;EACE,kBAAA;AAZV;AAcU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAZZ;AAeU;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AAbZ;AAeY;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAbd;AAec;EACE,eAAA;AAbhB;AAgBc;EACE,gBAAA;AAdhB;AAqBU;EACE,qBAAA;AAnBZ;AAqBY;EACE,qBAAA;AAnBd;AAuBU;EACE,mBAAA;AArBZ","sourcesContent":["@import \"./src/assets/css/common/variables\";\r\n\r\n.services-section {\r\n  padding: 8rem 0;\r\n\r\n  .latest-news-update-btn-container {\r\n    position: relative;\r\n\r\n    .update-btn {\r\n      position: absolute;\r\n      top: -115px;\r\n      right: 1rem;\r\n    }\r\n  }\r\n\r\n  .services-update-btn-container {\r\n    position: relative;\r\n\r\n    .update-btn {\r\n      position: absolute;\r\n      right: 1rem;\r\n      top: 65px;\r\n    }\r\n  }\r\n}\r\n\r\n.services-update-section {\r\n\r\n  .custom-container {\r\n\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 2rem;\r\n      min-height: 55vh;\r\n      font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .content-body {\r\n      margin: 3rem auto 0;\r\n\r\n      .form__div-container {\r\n        margin-bottom: 2.5rem;\r\n\r\n        .service-image-container {\r\n          position: relative;\r\n\r\n          .service-icon {\r\n            height: 100px;\r\n            width: 100px;\r\n            object-fit: contain;\r\n          }\r\n\r\n          .image-uploader {\r\n            position: absolute;\r\n            top: -30px;\r\n            left: 85px;\r\n\r\n            .icon-update-btn {\r\n              height: 40px;\r\n              width: 40px;\r\n              background: #b4b4b4;\r\n              color: #fff;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              border-radius: 100%;\r\n              cursor: pointer;\r\n              transition: .4s;\r\n\r\n              .fa-pencil {\r\n                font-size: 18px;\r\n              }\r\n\r\n              &:hover {\r\n                background: gray;\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .form__div {\r\n          .form__input {\r\n            border-color: #878787;\r\n\r\n            &:focus {\r\n              border-color: #1a73e8;\r\n            }\r\n          }\r\n\r\n          .form__label {\r\n            background: #E0E7FF;\r\n          }\r\n        }\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
